module.exports = __webpack_public_path__ + "img/banners.d10aae0e.png";